import { ReactNode } from 'react';

import classNames from 'classnames';

import { ChartControls } from '@ui/uikit/components/common/Chart/layout/ChartControls/ChartControls';
import { ChartPlot } from '@ui/uikit/components/common/Chart/layout/ChartPlot/ChartPlot';

type ChartProps = {
  children: ReactNode;
};

export const Chart = ({ children }: ChartProps) => {
  return (
    <div
      className={classNames(
        'h-full w-full bg-card-default-default-bg border border-base-border-medium rounded-3xl p-4 grid grid-rows-[auto_1fr] gap-4',
      )}
      style={{
        gridTemplateAreas: '"controls" "plot"',
      }}
    >
      {children}
    </div>
  );
};

Chart.Plot = ChartPlot;
Chart.Controls = ChartControls;
